<template>
  <div class="list-box bg-gray-100 rounded-lg">
    <div
      class="nav gap-x-3"
      title="HuiYiDetailHuiChangList"
      data-title="分会管理"
    >
      <el-segmented
        v-model="state.params.status"
        :props="{
          label: 'Text',
          value: 'Key',
        }"
        :options="[{ Text: '全部' }, ...$base.Common_Status]"
        class="c-segmented"
        @change="onLoad()"
      />
      <el-input
        v-model="state.params.keywords"
        class="c-search-white"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
      <el-button
        type="primary"
        icon="Plus"
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
      >
        新建
      </el-button>
    </div>
    <div class="content c-table-box mt-2 bg-white rounded-lg p-2.5">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) =>
              $buildTabIndex(state.params.page, state.params.limit, index)
          "
          align="center"
        />

        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="名称" label2="乙方" />
          </template>
          <template #default="{ row }">
            <c_tabgroup :value2="row.intro">
              <template #top>
                <strong>{{ row.name }}</strong>
              </template>
              <template #bottom>
                <text>{{ row.billUnit?.name }}</text>
                <text class="text-gray-400 text-xs ml-1">
                  {{ "[" + row.billUnit?.number + "]" }}
                </text>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column label="类型" :width="120" align="center">
          <template #default="{ row }">
            <c_status
              arrName="Meeting_Place_Type"
              :value="row.type"
              class="m-auto"
            />
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="场地" label2="地址" />
          </template>
          <template #default="{ row }">
            <c_tabgroup :value2="row.hotel?.address">
              <template #top>
                <strong>
                  {{ row.hotel?.name + "-" + row.hotelHall?.name }}
                </strong>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column label="关联日程" :width="120" align="center">
          <template #default="{ row }">
            <text>{{ row.schedule_count }}</text>
          </template>
        </el-table-column>
        <el-table-column label="负责人" :width="140">
          <template #default="{ row }">
            <text>{{ row.belonger_name }}</text>
            <text class="text-gray-400 text-xs ml-1">
              {{ row.belonger_department_name }}
            </text>
          </template>
        </el-table-column>
        <el-table-column label="序号" prop="sort" :width="120" align="center" />
        <el-table-column
          label="备注"
          prop="intro"
          :width="160"
          :formatter="$tab_TextFormat"
        />
        <el-table-column label="状态" align="center" :width="100">
          <template #default="{ row }">
            <el-switch
              v-model="row.status"
              active-text="启用"
              inactive-text="禁用"
              :active-value="1"
              :inactive-value="0"
              :disabled="!row.id"
              inline-prompt
              @change="onUpdateStatus($event, row)"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" :width="160">
          <template #default="{ row }">
            <el-button
              type="warning"
              :icon="Edit"
              link
              @click="
                state.selectId = row.id;
                state.showInfo = true;
              "
              >编辑
            </el-button>
            <el-button type="danger" :icon="Delete" link @click="onDelete(row)"
              >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
  </div>
  <el-dialog
    v-model="state.showInfo"
    :title="`${state.selectId ? '编辑' : '新建'}分会`"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showInfo = false;
      }
    "
  >
    <c_info
      :meeting_id="props.meeting_id"
      :id="state.selectId"
      @close="
        state.showInfo = false;
        onLoad();
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  meeting_place_page,
  meeting_place_updateStatus,
  meeting_place_delete,
} from "@/http/meeting";
import { post_response, onDeleteConfirm } from "@/utils/funcs";
import { ElMessageBox } from "element-plus";

import c_info from "./Info.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  props: {
    meeting_id: Number,
  },
  components: {
    c_info,
  },
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      state.params.meeting_id = props.meeting_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      meeting_place_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    const onUpdateStatus = (value, row) => {
      ElMessageBox.confirm(
        `您确定${
          row.status == 1
            ? '<strong style="color: var(--el-color-success);">启用</strong>'
            : '<strong style="color: var(--el-color-danger);">禁用</strong>'
        }该分会吗？`,
        "状态变更",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          customClass: "c-delete-dialog",
          cancelButtonClass: "is-plain",
        },
      )
        .then(() => {
          meeting_place_updateStatus({
            id: row.id,
            status: row.status,
          }).then((res) => {
            post_response(res, onLoad);
          });
        })
        .catch(() => {
          row.status = value ? 0 : 1;
        });
    };

    //删除
    const onDelete = (row) => {
      onDeleteConfirm(meeting_place_delete, row.id, onLoad, {
        filed: "分会",
        name: row.name,
      });
    };

    return { state, props, onLoad, onUpdateStatus, onDelete };
  },
};
</script>

<style lang="scss" scoped></style>
